var _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTextBox(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 595,
    height: 88,
    viewBox: "0 0 595 88",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M600.5 7.73433C600.5 3.73892 597.261 0.5 593.266 0.5H7.73431C3.73889 0.5 0.5 3.73892 0.5 7.73433V59.0028C0.5 60.8064 1.17371 62.545 2.3891 63.8776L12.2189 74.6562L12.2253 74.6631L22.2426 85.2402C23.6089 86.6828 25.5083 87.5 27.4952 87.5H593.266C597.261 87.5 600.5 84.2611 600.5 80.2657V7.73433Z",
    fill: "#1C223B",
    fillOpacity: 0.1,
    stroke: "url(#paint0_linear_1_245)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_245",
    x1: 300.5,
    y1: 0,
    x2: 300.5,
    y2: 88,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E0C528"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7C13A"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTextBox);
export default __webpack_public_path__ + "static/media/textBox.d774160f52da77884a6cb245fc7de515.svg";
export { ForwardRef as ReactComponent };